import { render, staticRenderFns } from "./NewAutoShareOnFacebookModal.vue?vue&type=template&id=07215415&scoped=true&"
import script from "./NewAutoShareOnFacebookModal.vue?vue&type=script&lang=js&"
export * from "./NewAutoShareOnFacebookModal.vue?vue&type=script&lang=js&"
import style0 from "./NewAutoShareOnFacebookModal.vue?vue&type=style&index=0&id=07215415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07215415",
  null
  
)

export default component.exports